import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { WebOpsActionCreator, FrameworkActionCreator } from 'src/store/states';
import IndividualServices from 'src/components/IndividualServices/IndividualServices';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    items: state.WebOps.WebOps,
    itemServiceChecked: state.WebOps.checkedWebOps,
    theme: state.Framework.theme,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    maintContracts: state.AdditionalServices.maintContractData.maintContracts,
    gmDealerCanEarn: state.Specs.specs?.gmDealerCanEarn,
    vehicles: state.Vehicles.vehicles,
    selectedVehicles: state.Vehicles.selectedVehicle,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    locale: state.Framework.locale,
});

const mapDispatchToProps = {
    toggleItem: WebOpsActionCreator.ToggleItems,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    toggleOpsLangLits: WebOpsActionCreator.ToggleOpsLangLits,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(IndividualServices);